import {BreadCrumbsProp} from './bread-crumb';
import Comparable from './comparable';
import {ResourceType} from './resource-type';

export default class TabItem implements Comparable<TabItem>{
    index: number = 0;
    value?: number;
    label: string = '';
    breadCrumbs: BreadCrumbsProp[] = [];
    docId?: number;
    type: ResourceType = ResourceType.UNKNOWN;
    objectToEdit: any;

    /**
     * Unique identifier for this tab instance, generated once when the tab is created.
     *
     * IMPORTANT: This uid is used as the React key when rendering tabs. Unlike `index`,
     * which changes when tabs are reordered or removed, `uid` remains stable throughout
     * the tab's lifetime. This prevents React from unnecessarily unmounting and remounting
     * tab content when other tabs are closed, which would cause data loss and re-fetching.
     */
    uid: string = '';

    constructor(type: ResourceType, docId: number);
    constructor(type: ResourceType, docId: number, index: number, value: number, label: string, breadCrumbs: BreadCrumbsProp[]);

    constructor(...args: any[]) {
        if (args.length === 2) {
            this.docId = args[1];
            this.type = args[0];
        } else if (args.length === 6) {
            this.type = args[0];
            this.docId = args[1];
            this.index = args[2];
            this.value = args[3];
            this.label = args[4];
            this.breadCrumbs = args[5];
        }
    }

    compareTo(other: TabItem): number {
        if (this.type < other.type || !this.docId && other.docId) {
            return -1;
        }
        if (this.type > other.type || this.docId && !other.docId) {
            return 1;
        }
        return this.docId && other.docId ? this.docId - other.docId : 0;
    }
}